<div class="mat-typography mat-body mat-app-background">
  <h2 class="drug-cost-header">{{ sectionHeading ? sectionHeading : defaultHeading }}</h2>

  @if (yearlyCostDescriptionContent) {
    <div class="monthly-cost-description" [innerHTML]="yearlyCostDescriptionContent"></div>
  }

  <div class="bar-layout" >
    <div id="{{ 'barchart-' + retailMailOrderSwitch}}"></div>
  </div>
  <div class="donut-layout">
    <div id="{{ 'donutchart-' + retailMailOrderSwitch}}"></div>
  </div>
</div>
